import { render, staticRenderFns } from "./CatalogEdit.vue?vue&type=template&id=0cc494ad"
import script from "./CatalogEdit.vue?vue&type=script&lang=js"
export * from "./CatalogEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports